import { HedgePlanSeasonModel, MatrixTerm } from '../../../../Generated/Commodity-Management-Api';

export interface SeasonPeriod {
  year: number;
  term: MatrixTerm;
  key: string;
  label: string;
  // First day of the season's first delivery month.
  startDate?: string;
  // Last day of the season's last delivery month.
  endDate?: string;
}

export function toSeasonPeriod(season: HedgePlanSeasonModel): SeasonPeriod {
  const year = season.year ?? 0;
  const term = season.term ?? MatrixTerm.Annual;

  return { year, term, key: `${year}-${term}`, label: season.label, startDate: season.startDate, endDate: season.endDate };
}

export { months as MONTH_NAMES } from '../../../../Helpers';
